/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { UPDATE_ENROLLED_CLASS_DATA, LOGOUT_SUCCESS } from '../Auth/actions';
import {
  SET_ENROLMENTS,
  SET_ENROLMENT_DISPLAYED,
  LEAVE_COHORTS,
  CHECK_ENROLMENT_CONSENT_PERMISSION_SUCCESS,
} from './actions';
import { COURSE_NAVIGATION_DATA_SET } from '../CourseNavigationInfo/actions';
import {
  COURSE_ADD_ADMIN,
  FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS,
  FETCH_ENROLLED_CLASS_DATA_SUCCESS,
} from '../Courses/actions';
import { UPDATE_COHORT_ROLES } from '../CohortRoles/actions';
import { FETCH_STUDENT_CERTIFICATIONS_SUCCESS } from '../Certification/actions';

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function Enrolments(state = Immutable.Map(), action = { type: null }) {
  switch (action.type) {
    case SET_ENROLMENTS:
    case FETCH_STUDENT_CERTIFICATIONS_SUCCESS:
    case FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS:
    case COURSE_NAVIGATION_DATA_SET: {
      const enrolments = Immutable.fromJS(action.enrolments);
      let newState = state;
      for (const enrolment of enrolments.values()) {
        newState = newState.set(enrolment.get('id'), enrolment);
      }
      return newState;
    }
    case FETCH_ENROLLED_CLASS_DATA_SUCCESS:
    case UPDATE_ENROLLED_CLASS_DATA: {
      const enrolments = Immutable.fromJS(action.enrolments);
      let newState = state;
      if (action.currentUserId) {
        // In case the user has left some of the courses they were previously enrolled in
        newState = newState.filter(
          (enrolment) => enrolment.get('userId') !== action.currentUserId
        );
      }
      for (const enrolment of enrolments.values()) {
        newState = newState.set(enrolment.get('id'), enrolment);
      }
      return newState;
    }
    case CHECK_ENROLMENT_CONSENT_PERMISSION_SUCCESS: {
      const { enrolmentId, hasEnrolmentConsentPermission } = action;
      return state.setIn(
        [enrolmentId, 'hasEnrolmentConsentPermission'],
        hasEnrolmentConsentPermission
      );
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }
    case COURSE_ADD_ADMIN: {
      const enrolment = Immutable.fromJS(action.enrolment);
      return state.set(enrolment.get('id'), enrolment);
    }
    case UPDATE_COHORT_ROLES: {
      let newState = state;
      for (const role of action.roles) {
        const roleEnrolment = state.find(
          (enrolment) =>
            enrolment.get('cohortPath') === role.cohort &&
            role.user === enrolment.get('userId')
        );
        const isStaff = Immutable.fromJS(role.roles).includes('facilitator');
        if (roleEnrolment) {
          newState = newState.setIn(
            [roleEnrolment.get('id'), 'staff'],
            isStaff
          );
        }
      }
      return newState;
    }
    case SET_ENROLMENT_DISPLAYED: {
      return state.setIn([action.enrolmentId, 'display'], action.display);
    }
    case LEAVE_COHORTS: {
      const { enrolmentIds } = action;
      let newState = state;

      enrolmentIds.forEach((id) => {
        newState = newState.remove(id);
      });

      return newState;
    }
    default:
      return state;
  }
}
